import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { routerTransition } from '../app.router.animations';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    animations: [routerTransition()],
    host: { '[@routerTransition]': '' }
})
export class LogoutComponent implements OnInit {
    constructor(private dialog: MatDialog) {
        dialog.closeAll();
    }

    ngOnInit(): void {
        //
    }
}
